import { render, staticRenderFns } from "./RmaItemCard.vue?vue&type=template&id=16666728&scoped=true"
import script from "./RmaItemCard.vue?vue&type=script&lang=js"
export * from "./RmaItemCard.vue?vue&type=script&lang=js"
import style0 from "./RmaItemCard.vue?vue&type=style&index=0&id=16666728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16666728",
  null
  
)

export default component.exports